import React from 'react';
import PropTypes from 'prop-types';
import StatusIcon from 'modules/common/components/StatusIcon';

function TransactionRow({
  title,
  value,
  addClass,
  addColor,
  description,
  permitType,
  transformCss,
  className,
}) {
  return (
    <tr className={`row text-dark p-1 mx-0 ${className}`}>
      <td className="col-6">
        {description ? (
          <>
            <b className={addColor ? 'cms-text-primary' : 'text-row'}>
              {title}
            </b>
            <span className="font-italic"> {description} </span>
          </>
        ) : (
          <>
            <b className={addColor ? 'cms-text-primary' : 'text-row'}>
              {title}
            </b>
          </>
        )}
      </td>
      <td className="col-6">
        {addClass ? (
          <StatusIcon value={value} permitType={permitType} />
        ) : (
          <p
            className={`p-justify m-0 ${transformCss ? 'title-case-css' : ''}`}
          >
            {' '}
            {value}{' '}
          </p>
        )}
      </td>
    </tr>
  );
}

TransactionRow.defaultProps = {
  addClass: false,
  addColor: false,
  value: null,
  description: null,
  permitType: null,
  transformCss: true,
  className: '',
};

TransactionRow.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  addClass: PropTypes.bool,
  addColor: PropTypes.bool,
  description: PropTypes.string,
  permitType: PropTypes.string,
  transformCss: PropTypes.bool,
  className: PropTypes.string,
};

export default TransactionRow;